import React from 'react';
import './UpgradeAccountModal.css';

const UpgradeAccountModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target.className.includes('modal-overlay')) {
      onClose();
    }
  };

  const handleCopyAddress = () => {
    const address = '0x9727172c367b9955cc26310a6f8bba2877f351b9';
    navigator.clipboard.writeText(address).then(() => {
      // You could add a toast notification here
    }).catch(err => {
      console.error('Failed to copy address: ', err);
    });
  };

  return (
    <div className="upgrade-modal-overlay" onClick={handleOverlayClick}>
      <div className="upgrade-modal">
        <div className="upgrade-modal-header">
          <h2>Upgrade Account</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="upgrade-modal-content">
          <div className="upgrade-info">
            <p>ToxChat has no usage restrictions.</p>
            <p>Thank you for using our service. If it has been helpful to you, you can donate to support the project's progress. The project will be open-sourced and deployed later.</p>
          </div>
          
          <div className="donation-section">
            <h3>Donation Address (ETH):</h3>
            <div className="address-container">
              <span className="eth-address">0x9727172c367b9955cc26310a6f8bba2877f351b9</span>
              <button className="copy-btn" onClick={handleCopyAddress}>Copy</button>
            </div>
          </div>
          
          <div className="upgrade-footer">
            <button className="close-modal-btn" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeAccountModal;
